import i18n from "@/i18n";

export const userGroupMediaLibAclFields = [
    {
        key: "name",
        label: i18n.t("users.path"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "claim",
        label: i18n.t("users.permissions")
    },
    {
        key: "actions",
        label: ""
    }
];
